<template>
	<v-card
		tile
		outlined
	>
		<MyMap
			v-bind:content="content"
			v-bind:setActiveWhenLoaded="true"
		/>
	</v-card>
</template>

<script>
	import MyMap from "../map/MyMap";
	import CommonHelper from "../../../components/helpers/CommonHelper";
	import cloneDeep from "lodash/cloneDeep";

	export default {
		props: {
			cfg: Object
		},
		data: function(){
			var data = {
				content: {}
			};
			if (this.cfg) {
				Object.assign(data.content, cloneDeep(this.cfg.data));
			}
			return data;
		},
		components: {
			MyMap
		},
		methods: {
			getPageData4Save: function(){
				var pageData4Save = {
					mapConfig: CommonHelper.getMapConfig(this.content.myMap)
				};
				if (this.content.myMap.printExtentFeature) {
					pageData4Save.gridParams = this.content.myMap.printExtentFeature.get("grid-params");
				}
				if (this.content.myMap.gridLayer) {
					pageData4Save.gridParams.ignore = [];
					this.content.myMap.gridLayer.getSource().getFeatures().forEach(function(feature){
						if (feature.get("ignore")) {
							var pos = feature.get("pos");
							if (pos) {
								pageData4Save.gridParams.ignore.push(pos.join("-"));
							}
						}
					});
				}
				return pageData4Save;
			}
		}
	}
</script>

<style scoped>
	.v-card {
		height: 100%;
		min-height: 100px;
	}
</style>